import { useEffect } from 'react';
import { Footer } from '../Commun/Footer';
import Hearder from '../Commun/Header';
import { HomeBanner } from '../HeaderBanner/HomeBanner';
import { Aminities } from '../Pages/Aminities';
import { Room } from '../Pages/Room';
import { ChooseSection } from '../Pages/ChooseSection';
import '../../../FrontendPage.css';
import { Explore } from '../Pages/Explore';
import { OfferCard } from '../Pages/OfferCard';
import { RealReviewsSection } from '../Pages/RealReviewsSection';

const Home = () => {
  useEffect(() => {

    // Filter pills toggle
    const filterPills = document.querySelectorAll(".zzx_filter-pill");

    filterPills.forEach((pill) => {
      pill.addEventListener("click", () => {
        filterPills.forEach((p) => p.classList.remove("active"));
        pill.classList.add("active");
      });
    });

    // Search tabs toggle
    const searchTabs = document.querySelectorAll(".zzx_search-tab");

    searchTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        searchTabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
      });
    });

    // Wishlist toggle
    const wishlistBtns = document.querySelectorAll(".zzx_prop-wishlist");

    wishlistBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();

        const icon = btn.querySelector("i");

        icon.classList.toggle("bi-heart");
        icon.classList.toggle("bi-heart-fill");

        icon.style.color = icon.classList.contains("bi-heart-fill")
          ? "#e53935"
          : "";
      });
    });

    // Scroll to top visibility
    const handleScroll = () => {
      const btn = document.querySelector(".zzx_scroll-top");

      if (btn) {
        btn.style.opacity = window.scrollY > 300 ? "1" : "0";
        btn.style.visibility = window.scrollY > 300 ? "visible" : "hidden";
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, []);

  return (
    <>
      <Hearder />
      <HomeBanner />
      {/* <Explore /> */}
      <Room />
      <OfferCard />
      <ChooseSection />
      <Aminities />
      <RealReviewsSection />
      <Footer />

      {/* Scroll to Top */}
      <button className="zzx_scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth", })} >
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
};

export default Home;